import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "./Menu";
import CarSolvencia from "../element/CarSolvencia";
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";
import Footer from './Footer';

const Solvencia = () => {

  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem('dataUser');
  const [solvencia, setSolvencia] = useState({});
  const [cargando, setCargando] = useState(true);

  useEffect(() => {

    if (datos) {
      let cred = JSON.parse(datos);
      dataUser.token = cred.token;
      dataUser.nombre = cred.nombre;
      dataUser.carnet = cred.carnet;

      let solvencia = GetFetch.solvencia(dataUser.carnet, dataUser.token);
      solvencia.then((dataSolvencia) => {
        setSolvencia(dataSolvencia);
        setCargando(false);
      }).catch(() => setCargando(false));

      loadMenu();
    } else {
      history.push("/");
    }
  }, [datos, history, dataUser]);

  const componentes = solvencia.length > 0 ? solvencia : [];
  const todoSolvente = componentes.length > 0 && componentes.every((c) => c.solvencia === 'Solvente');
  const pendientes = componentes.filter((c) => c.solvencia !== 'Solvente').length;

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Solvencia financiera</h2>

        {cargando ? (
          <SkeletonCard rows={4} />
        ) : componentes.length > 0 ? (
          <>
            {todoSolvente ? (
              <div className="alert alert-success" role="alert">
                <i className="fa fa-check-circle mr-2" aria-hidden="true"></i>
                <b>Estás solvente.</b> Todos los componentes administrativos están al día.
              </div>
            ) : (
              <div className="alert alert-danger" role="alert">
                <i className="fa fa-exclamation-circle mr-2" aria-hidden="true"></i>
                <b>Tienes {pendientes} {pendientes === 1 ? 'componente pendiente' : 'componentes pendientes'}.</b>{' '}
                Regulariza tu estado para acceder a todos los servicios.
              </div>
            )}

            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Componente administrativo</th>
                        <th scope="col">Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {componentes.map((element, i) => (
                        <CarSolvencia
                          key={i}
                          componente={element.componente}
                          solvencia={element.solvencia}
                        />
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        ) : (
          <EmptyState icon="fa-file-text-o" title="Sin información de solvencia">
            No hay componentes administrativos para mostrar en este momento.
          </EmptyState>
        )}
      </div>
    </div>
  );
};

export default Solvencia;
